import { render, staticRenderFns } from "./AdminPagination.vue?vue&type=template&id=5f12a972&scoped=true"
import script from "./AdminPagination.vue?vue&type=script&lang=js"
export * from "./AdminPagination.vue?vue&type=script&lang=js"
import style0 from "./AdminPagination.vue?vue&type=style&index=0&id=5f12a972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f12a972",
  null
  
)

export default component.exports